import { defineStore } from "pinia";
import axiosInstance from "../config/axios";

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            user: null,
            confirmedUsers: [],
            unconfirmedUsers: [],
            unVerifiedUsers: [],
            priceList: [],
            priceListRange: [],
            usersInvitations: [],
        };
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        confirmedAndUnconfirmedUsers(state) {
            return [...state.confirmedUsers, ...state.unconfirmedUsers, ...state.unVerifiedUsers];
        },
    },
    actions: {
        fetchUser() {
            return axiosInstance.get("/v1/user").then((response) => (this.user = response.data.data));
        },
        updateUserProfile(userProfileData) {
            return axiosInstance
                .post("/v1/home/update-user-settings", userProfileData)
                .then((response) => (this.user = response.data.data));
        },
        updateUserInviteUsersPermission(userId) {
            return axiosInstance.put(`/v1/admin/users/${userId}/toggle-invite-users`).then((response) => {
                this.confirmedAndUnconfirmedUsers.find((user) => user.id === response.data.data.id).invite_users =
                    response.data.data.invite_users;
            });
        },
        updateUserRole({ userId, roleId }) {
            return axiosInstance.put(`/v1/admin/users/${userId}/role/${roleId}`).then((response) => {
                const user = this.confirmedAndUnconfirmedUsers.find((user) => user.id === response.data.data.id);
                user.role = response.data.data.role;
                user.role_id = response.data.data.role_id;
            });
        },
        updateUserProperties(userPropertiesData) {
            return axiosInstance
                .put(`/v1/admin/users/${userPropertiesData.userId}/properties`, userPropertiesData.data)
                .then((response) => {
                    this.confirmedAndUnconfirmedUsers.find((user) => user.id === response.data.data.id).properties =
                        response.data.data.properties;

                    if (this.unconfirmedUsers.find((unconfirmedUser) => unconfirmedUser.id === response.data.data.id)) {
                        this.unconfirmedUsers = this.unconfirmedUsers.filter(
                            (unconfirmedUser) => unconfirmedUser.id !== response.data.data.id
                        );
                    }

                    if (this.unVerifiedUsers.find((unVerifiedUser) => unVerifiedUser.id === response.data.data.id)) {
                        this.unVerifiedUsers = this.unVerifiedUsers.filter(
                            (unVerifiedUser) => unVerifiedUser.id !== response.data.data.id
                        );
                    }

                    if (
                        this.confirmedUsers.find((confirmedUser) => confirmedUser.id === response.data.data.id) ==
                        undefined
                    ) {
                        this.confirmedUsers.push(response.data.data);
                    }
                });
        },
        deleteUserProperty(userPropertyData) {
            return axiosInstance
                .delete(`/v1/admin/users/${userPropertyData.userId}/properties`, userPropertyData)
                .then((response) => {
                    this.confirmedAndUnconfirmedUsers.find((user) => user.id === response.data.data.id).properties =
                        response.data.data.properties;
                });
        },
        deleteUser(user) {
            return axiosInstance.delete(`/v1/admin/users/${user.id}`).then(() => {
                this.confirmedUsers = this.confirmedUsers.filter((confirmedUser) => confirmedUser.id !== user.id);
                this.unconfirmedUsers = this.unconfirmedUsers.filter(
                    (unconfirmedUser) => unconfirmedUser.id !== user.id
                );
            });
        },
        fetchConfirmedUsers() {
            return axiosInstance
                .get("/v1/admin/confirmed-users")
                .then((response) => (this.confirmedUsers = response.data.data));
        },
        fetchUnconfirmedUsers() {
            return axiosInstance
                .get("/v1/admin/unconfirmed-users")
                .then((response) => (this.unconfirmedUsers = response.data.data));
        },
        async fetchUnVerifiedUsers() {
            return axiosInstance
                .get("/v1/admin/unverified-users")
                .then((response) => (this.unVerifiedUsers = response.data.data));
        },
        inviteUser(userData) {
            return axiosInstance.post("/v1/admin/users/invite", userData);
        },
        inviteBusinessUser(userData) {
            return axiosInstance.post("/v1/super-admin/invite-business", userData);
        },
        fetchPriceList(shopId) {
            return axiosInstance.get(`/v1/home/price-list/${shopId}`).then((response) => {
                this.priceList = response.data.data;
                this.priceListRange = response.data.priceListRange;
            });
        },
        async fetchUserInvitations() {
            return axiosInstance.get(`/v1/admin/users-invitations`).then((response) => {
                this.usersInvitations = response.data;
            });
        },
        async resendInvite(userData) {
            return axiosInstance.post(`/v1/admin/resend-invite`, userData);
        },
        async deleteInvite(userData) {
            return axiosInstance.delete(`/v1/admin/delete-user-invite`, { params: userData });
        },
    },
});
